import React from 'react';
import { useRouter } from 'next/router';
import sendEvent from '../../helpers/tracking';
import { useMobile } from '../../helpers/hooks';

import './DashboardSliderList.scss';

export default function DashboardSliderList({ list }) {
  const router = useRouter();
  const [isMobile] = useMobile();

  return (
    <div className="dashboardSliderList">
      <h2 className="dashboardSliderList-title">
        Overig
      </h2>

      <ul className="dashboardSliderList-content">
        {list.map((item, idx) =>
          <li
            key={idx}
            className="dashboardSliderList-item"
            onClick={() => {
              if (isMobile) sendEvent(...item.tracking);

              router.push(item.link);
            }}>
            <img
              alt="item-image"
              src={item.imageUrl}
              className="dashboardSliderList-item-img"
            />

            <p className="dashboardSliderList-item-name">
              {item.name}
            </p>
          </li>)}
      </ul>
    </div>
  );
}
